import React from 'react';
import { ResponsiveLayout } from '@/components/ResponsiveLayout';

export default function LogPage() {
  return (
    <ResponsiveLayout><div className="flex-1 min-h-screen bg-[#0A0A0B] text-[#F8F9FA]">
      
      <main className="flex-1 px-4 md:px-6 lg:px-8 py-6 md:py-8">
        <div className="mb-6">
          <h1 className="text-4xl font-bold font-heading text-[#F8F9FA] mb-2">
            Log
          </h1>
          <p className="text-[#ADB5BD]">Documentation & Accountability</p>
        </div>
        <div className="space-y-4">
          <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-lg font-semibold">Marketing CPM Optimization</h3>
                <p className="text-sm text-[#6C757D]">5 Jan 2025, 14:30</p>
              </div>
              <span className="text-xs text-[#06D6A0]">Fixed</span>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-xs text-[#ADB5BD]">Before Score</p>
                <p className="text-xl font-mono text-[#E63946]">55/100</p>
              </div>
              <div>
                <p className="text-xs text-[#ADB5BD]">After Score</p>
                <p className="text-xl font-mono text-[#06D6A0]">78/100</p>
              </div>
            </div>
            <p className="text-sm text-[#ADB5BD] mt-4">Outcome: Reduced CPM by 25%, increased CTR by 18%</p>
          </div>
          
          <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-lg font-semibold">Sales Closing Rate Improvement</h3>
                <p className="text-sm text-[#6C757D]">3 Jan 2025, 09:15</p>
              </div>
              <span className="text-xs text-[#06D6A0]">Fixed</span>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-xs text-[#ADB5BD]">Before Score</p>
                <p className="text-xl font-mono text-[#E63946]">52/100</p>
              </div>
              <div>
                <p className="text-xs text-[#ADB5BD]">After Score</p>
                <p className="text-xl font-mono text-[#FFB703]">65/100</p>
              </div>
            </div>
            <p className="text-sm text-[#ADB5BD] mt-4">Outcome: Improved response time, added follow-up automation</p>
          </div>
        </div>
      </main>
    </div>
    </ResponsiveLayout>
  );
}
